import { render, staticRenderFns } from "./RightFifth.vue?vue&type=template&id=47f89b19"
import script from "./RightFifth.vue?vue&type=script&lang=js"
export * from "./RightFifth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports